import GroupScreen from '../../components/layout/group-screen';
import { JOB_NAMES } from '../../constants/jobNames';
import PromptList from './prompt-list';
import PromptExecutionsList from '../prompt-executions/prompt-executions-list';

/** Prompts — merged screen for prompt master and its executions. */
const PromptsGroup = () => (
  <GroupScreen
    icon="pi pi-comments"
    iconBgColor="bg-indigo-600"
    title="Prompts"
    subtitle="Prompt master and execution history"
    testId="SCR-PromptsGroup"
    tabs={[
      { key: 'prompt-master', header: 'Prompt Master', leftIcon: 'pi pi-comments', jobs: [JOB_NAMES.PROMPT_MASTER], element: <PromptList embedded /> },
      { key: 'prompt-executions', header: 'Executions', leftIcon: 'pi pi-play-circle', jobs: [JOB_NAMES.PROMPT_EXECUTIONS], element: <PromptExecutionsList embedded /> },
    ]}
  />
);

export default PromptsGroup;
